import React from 'react';

import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from './AdminAuthContainer';
import PortalBody from './PortalBody';
import PortalHeader from './PortalHeader';
import PortalNav from './PortalNav';
import Loading from '../../pages/Loading';

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
`;

const Portal: React.FC = () => {
    const { isLoading } = useContainer(AdminAuthContainer);

    const ShowPortal = () => (
        <>
            <PortalNav />
            <PortalBody />
        </>
    );

    const Content = () => <ShowPortal />;

    if (isLoading) {
        return <Loading />;
    }

    return (
        <GridContainer>
            <PortalHeader />
            <Content />
        </GridContainer>
    );
};

export default Portal;
